<template>
  <div class="broadcasts">
    <h2 class="headline mb-3">LON {{ $t('Broadcast') }}</h2>
    <div style="margin-bottom: 15px">
      <div class="add-broadcast text-xs-center" @click="handleCreateBroadcast">
        <em class="fa fa-plus middle" />
        {{ $t('Add new broadcast') }}
      </div>
    </div>
    <LonBroadcastDraft
      ref="broadcastDraft"
      @edit="handleEdit"
      @copy="handleCopyBroadcast"
      @delete="handleDelete"
      @select="handleSelect"
    />
    <LonBroadcastSent
      ref="broadcastSent"
      @edit="handleEdit"
      @copy="handleCopyBroadcast"
      @delete="handleDelete"
      @select="handleSelect"
    />
  </div>
</template>
<script>
import LonBroadcastDraft from './LonBroadcastDraft.vue'
import LonBroadcastSent from './LonBroadcastSent.vue'
export default {
  components: {
    LonBroadcastDraft,
    LonBroadcastSent
  },
  methods: {
    handleCreateBroadcast() {
      this.$emit('create-broadcast')
    },
    handleEdit(broadcast) {
      this.$emit('edit', broadcast)
    },
    handleCopyBroadcast(broadcast) {
      this.$emit('copy', broadcast)
    },
    handleDelete(broadcast) {
      this.$emit('delete', broadcast)
    },
    handleSelect(broadcast) {
      this.$emit('select', broadcast)
    },
    handleReFetch() {
      if (this.$refs.broadcastDraft) this.$refs.broadcastDraft.handleReFetch()
      if (this.$refs.broadcastSent) this.$refs.broadcastSent.handleReFetch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastList.vue